* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: auto;
  margin-top: 20px;
}

.bundles-details-text {
  margin-top: calc(var(--spacer) * 2);
  text-align: left;
}

gz-radio {
  margin-bottom: var(--spacer);
}
